import styled from "styled-components";
import { MoonIcon, SunIcon } from "../icons";

interface ThemeToggleProps {
    toggle: () => void;
    mode: string;
}

const SwapMode = styled.div<{$isLight: boolean}>`
    height: 3rem;
    justify-content: center;
    align-content: center;
    cursor: pointer;
    color: ${props => props.$isLight ? "#000" : "#fff"};

    &:hover {
        color: ${props => props.theme.HEADER.THEME_ICON};
    }
`;

function ThemeToggle({toggle, mode}: ThemeToggleProps) {
    return (
        <SwapMode onClick={toggle} $isLight={mode === 'light'}>
            {mode === 'light' ? <MoonIcon /> : <SunIcon />}
        </SwapMode>
    );
}

export default ThemeToggle;